import { SiteRateSchedule } from '~hooks/useSiteRateSchedule/models';

import { SiteRateScheduleDTO } from './SiteRatesForm';

// Two Site Rate Schedules describe the same rate row when their
// matching conditions are equal — pickup/dropoff sites, material,
// equipment type, and jurisdiction. Rate values do not enter the
// comparison; they're what gets applied to a job, not what identifies
// the rule.
//
// Used by FreightRates' Copy & Edit recovery effect: when the source
// order's starred SRS id has been stripped from the loaded row (the
// SRS will be recreated server-side), match by conditions instead so
// the starred reference can be re-pointed at the matching row's
// clientKey and resolved to the new server id after save.
export const matchesStarredSrsConditions = (
  rate: SiteRateScheduleDTO,
  source: SiteRateSchedule,
): boolean =>
  (rate.pickupSite?.value ?? null) === (source.pickupSite?.id ?? null) &&
  (rate.dropoffSite?.value ?? null) === (source.dropoffSite?.id ?? null) &&
  (rate.material?.value ?? null) === (source.material?.id ?? null) &&
  (rate.equipmentType?.value ?? null) === (source.equipmentType?.id ?? null) &&
  (rate.jurisdiction ?? null) === (source.jurisdiction ?? null);
